import { GuideItem, GuideContent } from '../guides';

export const guide2Item: GuideItem = {
  id: "2",
  title: "Top 5 Korean Chicken Brands Loved by Foreigners",
  titleEn: "Top 5 Korean Chicken Brands Loved by Foreigners",
  titleJa: "外国人に大人気！韓国チキンブランドTOP5",
  titleZhCn: "外国人喜爱的韩国炸鸡品牌TOP5",
  titleZhTw: "外國人最愛的韓國炸雞品牌TOP5",
  image: "https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5.png",
  imageEn: "https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5.png",
  imageJa: "https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-JP.png",
  imageZhCn: "https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-CN.png",
  imageZhTw: "https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-TW.png",
  description: "The Ultimate Korean Chicken Guide for First-Time Visitors",
  descriptionEn: "The Ultimate Korean Chicken Guide for First-Time Visitors",
  descriptionJa: "初めての韓国旅行でも迷わない！チキン完全ガイド",
  descriptionZhCn: "第一次来韩国？这里是炸鸡入门指南！",
  descriptionZhTw: "第一次來韓國？這份炸雞指南請收好！"
};

export const guide2Content: GuideContent = {
  title: "Top 5 Korean Chicken Brands Loved by Foreigners",
  titleEn: "Top 5 Korean Chicken Brands Loved by Foreigners",
  titleJa: "外国人に大人気！韓国チキンブランドTOP5",
  titleZhCn: "外国人喜爱的韩国炸鸡品牌TOP5",
  titleZhTw: "外國人最愛的韓國炸雞品牌TOP5",
  subtitle: "The Ultimate Korean Chicken Guide for First-Time Visitors",
  subtitleEn: "The Ultimate Korean Chicken Guide for First-Time Visitors",
  subtitleJa: "初めての韓国旅行でも迷わない！チキン完全ガイド",
  subtitleZhCn: "第一次来韩国？这里是炸鸡入门指南！",
  subtitleZhTw: "第一次來韓國？這份炸雞指南請收好！",
  markdownContent: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5.png)

## 🍗 Foreigners' Favorite Korean Chicken Brands: Top 5 Picks

### — The Best Korean Fried Chicken, According to Global Taste Buds

You haven't truly experienced Korea until you've tried **Korean fried chicken** — crispy, juicy, and bursting with flavor.

But with **hundreds of options** out there, where should you start?

Here are the **Top 5 Korean chicken brands loved by international visitors**, based on global reviews, popularity in tourist areas, and ease of ordering through **delivery services**.

---

## 1. BBQ (Best of the Best Quality)

https://youtu.be/LcAdJMxpTXA

# (버튼 1)

Foreigners love BBQ for its **light yet ultra-crispy texture** and **premium feel**.

The use of olive oil and signature Golden Olive Chicken offer a clean, crunchy experience that feels familiar — but better.

---

## 2. **BHC (Better & Happier Choice)**

https://youtu.be/0d_0tVoDv2E

# (버튼 2)

With fun flavors like cheese, honey garlic, and a variety of sides, BHC brings **playful creativity** to fried chicken.

Foreigners are drawn to its **bold toppings and shareable items** like cheese balls and seasoned fries.

---

## 3. **Kyochon Chicken**

https://youtu.be/IxkzNfBy8qs

# (버튼 3)

Kyochon is loved for its **refined taste**, especially the garlic soy flavor that feels both unique and comforting.

The chicken is light, savory, and **less greasy**, making it a go-to for those who want flavor without heaviness.

---

## 4. **Nene Chicken**

https://youtu.be/NiJLHEH3APE

# (버튼 4)

Foreigners enjoy Nene's **sweet and spicy blends**, especially the *Swicy* and *Snowing Cheese* flavors.

Its **generous portions** and fun menus make it ideal for first-timers looking to try something new but safe.

---

## 5. **Goobne Chicken**

![대지 13.png](attachment:cc54864e-15d4-4e67-b20f-0ee23da3f9df:대지_13.png)

# (버튼 5)

Goobne offers **oven-roasted chicken** that's juicy without being fried — a perfect match for those who want something lighter.

Its **mild flavors and healthy image** make it popular with Western-style eaters looking for a balanced meal.
`,
  markdownContentEn: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5.png)

## 🍗 Foreigners' Favorite Korean Chicken Brands: Top 5 Picks

### — The Best Korean Fried Chicken, According to Global Taste Buds

You haven't truly experienced Korea until you've tried **Korean fried chicken** — crispy, juicy, and bursting with flavor.

But with **hundreds of options** out there, where should you start?

Here are the **Top 5 Korean chicken brands loved by international visitors**, based on global reviews, popularity in tourist areas, and ease of ordering through **delivery services**.

---

## 1. BBQ (Best of the Best Quality)

https://youtu.be/LcAdJMxpTXA

# (버튼 1)

Foreigners love BBQ for its **light yet ultra-crispy texture** and **premium feel**.

The use of olive oil and signature Golden Olive Chicken offer a clean, crunchy experience that feels familiar — but better.

---

## 2. **BHC (Better & Happier Choice)**

https://youtu.be/0d_0tVoDv2E

# (버튼 2)

With fun flavors like cheese, honey garlic, and a variety of sides, BHC brings **playful creativity** to fried chicken.

Foreigners are drawn to its **bold toppings and shareable items** like cheese balls and seasoned fries.

---

## 3. **Kyochon Chicken**

https://youtu.be/IxkzNfBy8qs

# (버튼 3)

Kyochon is loved for its **refined taste**, especially the garlic soy flavor that feels both unique and comforting.

The chicken is light, savory, and **less greasy**, making it a go-to for those who want flavor without heaviness.

---

## 4. **Nene Chicken**

https://youtu.be/NiJLHEH3APE

# (버튼 4)

Foreigners enjoy Nene's **sweet and spicy blends**, especially the *Swicy* and *Snowing Cheese* flavors.

Its **generous portions** and fun menus make it ideal for first-timers looking to try something new but safe.

---

## 5. **Goobne Chicken**

https://youtu.be/LPpdX3wV1pw

# (버튼 5)

Goobne offers **oven-roasted chicken** that's juicy without being fried — a perfect match for those who want something lighter.

Its **mild flavors and healthy image** make it popular with Western-style eaters looking for a balanced meal.
`,
  markdownContentJa: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-JP.png)

## 🍗 外国人に人気の韓国チキンブランド：おすすめTOP5

― 世界の味覚が選んだ、韓国フライドチキンの決定版 ―

韓国旅行で**韓国フライドチキン**を食べなきゃ、本当の韓国は語れません！

カリカリでジューシー、味付けも抜群のチキンは、一度食べたらやみつきに。

でも、ブランドの種類は**何百種類**もあって、どれを選べばいいのか迷ってしまいますよね？

ここでは、観光エリアでの人気度、デリバリーのしやすさ、海外レビューなどをもとに、

**外国人旅行者に特に人気の韓国チキンブランドTOP5**をご紹介します。

## 1. BBQ（ベスト・オブ・ベスト・クオリティ）

https://youtu.be/VINYSisyhTo

# (버튼 1)

BBQは、**軽やかで超サクサクな食感**と**高級感のある仕上がり**で外国人に大人気。

オリーブオイルを使用した「ゴールデンオリーブチキン」は、さっぱりとしながらもしっかりとした旨味があり、

「馴染みのある味だけど、ワンランク上」な体験ができます。

---

## 2. **BHC (Better & Happier Choice)**

https://youtu.be/YIOaKvFV8ko

# (버튼 2)

チーズ味やハニーガーリックなど、ユニークで楽しいフレーバーが揃うBHCは、
遊び心あふれる創造性が魅力のフライドチキンブランドです。
チーズボールや味付きポテトなど、トッピングが豪快でシェアしやすいメニューが、外国人旅行者に大人気です。

---

## 3. キョチョンチキン（Kyochon Chicken）

https://youtu.be/yMOzH-s0IWk

# (버튼 3)

キョチョンは特に「ガーリック醤油」味が人気で、ユニークさと親しみやすさを兼ね備えた上品な味わいが魅力です。
チキン自体は軽くてしっかり旨味があり、脂っこさも控えめなので、重たくない味を求める人にぴったりです。

---

## 4. ネネチキン（Nene Chicken）

https://youtu.be/NiJLHEH3APE

# (버튼 4)

ネネチキンは「スイシー（甘辛）」や「スノーイングチーズ」など、
甘さと辛さが絶妙にミックスされたフレーバーが外国人旅行者に人気です。
ボリュームたっぷりで楽しいメニューが揃っており、「ちょっと冒険したいけど、安心して食べられる味」を求める初めての人にもぴったりです。

---

## 5. グッネチキン（Goobne Chicken）

https://youtu.be/LPpdX3wV1pw

# (버튼 5)

グッネチキンは、揚げずにオーブンで焼き上げるジューシーなローストチキンが特徴。
「油っこくないけど美味しい」を求める方にぴったりです。
マイルドな味付けとヘルシーなイメージで、欧米スタイルの食事を好む人や、バランス重視の方から支持されています。
`,
  markdownContentZhCn: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-CN.png)

## 🍗 外国人最喜爱的韩国炸鸡品牌：TOP5精选

### —— 全球味蕾认证的最佳韩式炸鸡品牌 ——

来到韩国，如果没吃过**韩式炸鸡**，那就不算真正体验过韩国！

外酥里嫩、香味十足，每一口都是满足。

但韩国有**成百上千的炸鸡品牌**，你该从哪一家开始吃起呢？

我们根据海外评价、旅游区人气、以及**外卖服务的便利性**，

为你精选出**最受外国人欢迎的TOP5韩国炸鸡品牌**！

## 1. BBQ（Best of the Best Quality）

https://youtu.be/VINYSisyhTo

# (버튼 1)

BBQ凭借清爽酥脆的口感和高端质感，深受外国人喜爱。
采用橄榄油炸制的招牌"黄金橄榄炸鸡"，口感干净、酥脆，
既熟悉又升级，是"熟悉中带点惊喜"的美味体验。

---

## 2. **BHC (Better & Happier Choice)**

https://youtu.be/YIOaKvFV8ko

# (버튼 2)

BHC以奶酪、蜂蜜蒜香等趣味口味出名，给炸鸡增添了创意与趣味。
奶酪球、调味薯条等丰富的配料和适合分享的小食，特别受到外国人的喜爱。

---

## 3. Kyochon Chicken（桥村炸鸡）

https://youtu.be/yMOzH-s0IWk

# (버튼 3)

Kyochon以细腻的口味著称，尤其是大蒜酱油口味，既特别又令人安心。
炸鸡酥香不腻，油脂较少、味道纯正，非常适合喜欢轻盈口感的食客。

---

## 4. Nene Chicken（奈奈炸鸡）

https://youtu.be/NiJLHEH3APE

# (버튼 4)

Nene以*Swicy（甜辣）和Snowing Cheese（起司雪花）*等口味著称，
甜辣交融的独特风味深受外国人喜爱。
分量充足，菜单有趣，很适合想尝试新口味但又不想冒险的炸鸡新手。

---

## 5. Goobne Chicken（纽宾炸鸡）

https://youtu.be/LPpdX3wV1pw

# (버튼 5)

Goobne主打不油炸、纯烤制的鸡肉，外嫩内多汁，非常适合想吃得轻盈又健康的人。
因其清淡口味和健康形象，深受追求均衡饮食的西式食客喜爱。
`,
  markdownContentZhTw: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%8E%E1%85%B5%E1%84%8F%E1%85%B5%E1%86%AB%E1%84%87%E1%85%B3%E1%84%85%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3-TOP5-TW.png)

## 🍗 外國人最愛的韓國炸雞品牌：TOP5推薦

—— 全球吃貨認證！最好吃的韓式炸雞就在這裡 ——

來到韓國，沒吃過韓式炸雞，就等於沒來過韓國！
外皮酥脆、肉質多汁、醬料濃郁，每一口都讓人上癮。

但面對市面上幾百種炸雞品牌，到底該從哪家開始嘗試呢？

我們根據全球旅客的評價、觀光區熱度與外送便利性，
精選出最受外國人喜愛的TOP5韓國炸雞品牌！

## 1. BBQ（Best of the Best Quality）

https://youtu.be/VINYSisyhTo

# (버튼 1)

BBQ以輕盈又超酥脆的口感與高質感風格，深受外國人歡迎。
招牌的「黃金橄欖炸雞」使用橄欖油酥炸，吃起來清爽不油膩、香酥可口，
是一種「熟悉又升級」的美味體驗。

---

## 2. **BHC (Better & Happier Choice)**

https://youtu.be/YIOaKvFV8ko

# (버튼 2)

BHC主打起司、蜂蜜蒜香等多樣化風味，讓炸雞充滿創意與玩心。
像是起司球、調味薯條這類配料豪華、適合分享的小點，深受外國旅客喜愛。

---

## 3. Kyochon Chicken（橋村炸雞）

https://youtu.be/yMOzH-s0IWk

# (버튼 3)

Kyochon以細緻的風味廣受歡迎，尤其是大蒜醬油口味，獨特中帶有熟悉感，令人安心。
雞肉香而不膩，油感較低、味道濃郁，非常適合想吃得清爽又有滋味的旅客。

---

## 4. Nene Chicken（奈奈炸雞）

https://youtu.be/NiJLHEH3APE

# (버튼 4)

Nene的甜辣融合口味像是Swicy與Snowing Cheese深受外國人歡迎，
香甜又帶點刺激的口感，讓人一吃就上癮。
份量十足、菜單多樣又有趣，非常適合初次嘗試韓式炸雞又希望保守一點的食客。

---

## 5. Goobne Chicken（紐賓炸雞）

https://youtu.be/LPpdX3wV1pw

# (버튼 5)

Goobne提供的是烤製而非油炸的雞肉，保有多汁口感，卻更加清爽不膩。
因為其溫和口味與健康形象，特別受到偏好西式飲食或重視飲食均衡的旅客喜愛。
`,
  inlineButtons: [
    {
      id: "1",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      franchiseId: "Ut2NoLs3",
      franchiseName: "BBQ",
    },
    {
      id: "2",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      franchiseId: "Jk5WeHw4",
      franchiseName: "BHC",
    },
    {
      id: "3",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      franchiseId: "Lc5RcSy9",
      franchiseName: "Kyochon Chicken",
    },
    {
      id: "4",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      franchiseId: "Pq1UkOh4",
      franchiseName: "Nene Chicken",
    },
    {
      id: "5",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      franchiseId: "Xb1JhWt0",
      franchiseName: "Goobne Chicken",
    },
  ],
}; 